import { render } from "./AppConfigForm.vue?vue&type=template&id=7794d450&scoped=true"
import script from "./AppConfigForm.vue?vue&type=script&lang=js"
export * from "./AppConfigForm.vue?vue&type=script&lang=js"

import "./AppConfigForm.vue?vue&type=style&index=0&id=7794d450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7794d450"]])

export default __exports__